var _defs, _rect, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgStoreImgGrey = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "store-img-grey_svg__Layer_1",
  width: "1em",
  height: "1em",
  viewBox: "0 0 59.5 53.5"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".store-img-grey_svg__st0{fill:none;stroke:#8487a0;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.5px}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 37.2,
  height: 37.2,
  x: 4,
  y: 10.7,
  className: "store-img-grey_svg__st0",
  rx: 4,
  ry: 4
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 15.1,
  cy: 21.7,
  r: 3.9,
  className: "store-img-grey_svg__st0"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M40.1 34.3 29.7 23.9 7 46.8",
  className: "store-img-grey_svg__st0"
})));
export { SvgStoreImgGrey as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMjFtbSIgaGVpZ2h0PSIxOC45bW0iIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDU5LjUgNTMuNSI+CiAgPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI5LjMuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDIuMS4wIEJ1aWxkIDE0NikgIC0tPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuc3QwIHsKICAgICAgICBmaWxsOiBub25lOwogICAgICAgIHN0cm9rZTogIzg0ODdBMDsKICAgICAgICBzdHJva2UtbGluZWNhcDogcm91bmQ7CiAgICAgICAgc3Ryb2tlLWxpbmVqb2luOiByb3VuZDsKICAgICAgICBzdHJva2Utd2lkdGg6IDMuNXB4OwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8cmVjdCBjbGFzcz0ic3QwIiB4PSI0IiB5PSIxMC43IiB3aWR0aD0iMzcuMiIgaGVpZ2h0PSIzNy4yIiByeD0iNCIgcnk9IjQiLz4KICA8Y2lyY2xlIGNsYXNzPSJzdDAiIGN4PSIxNS4xIiBjeT0iMjEuNyIgcj0iMy45Ii8+CiAgPHBvbHlsaW5lIGNsYXNzPSJzdDAiIHBvaW50cz0iNDAuMSAzNC4zIDI5LjcgMjMuOSA3IDQ2LjgiLz4KPC9zdmc+";